import Styles from './CalculatorMob.module.css'
import { Grid2, Typography, Box, Button } from "@mui/material";
import Calci from "../../../ui-utils/latestPics/calci.svg"
import { useNavigate } from 'react-router-dom';
import { useLanguage } from "../../../Context/LangContext";
import en from "../../../i18n/English/Home/cal.json";
import hi from "../../../i18n/Hindi/Home/cal.json";
import kn from "../../../i18n/Kannada/Home/cal.json";
import ma from "../../../i18n/Marathi/Home/cal.json";
import gu from "../../../i18n/Gujarati/Home/cal.json";
export default function CalculatorMob() {
  const navigate=useNavigate()
    const { language } = useLanguage();
    const translations = { en, hi, kn, ma, gu };
    const t = translations[language];
    return (
        <>
            <Box className={Styles.outerCard}>
                <div className={Styles.headingContainer}>
                    <div className={Styles.gradientBackground}></div>
                    <Typography className={Styles.heading} style={{ fontWeight: 600 }}>
                        {t.heading}
                    </Typography>
                </div>
                <Grid2 >


                    <Grid2 className={Styles.buttonCard}>
                        <Button className={Styles.button1} onClick={()=>{navigate("/tools-calculators/margin")
                       window.scrollTo(0, 0)
                      }}>
                            {t.buttons[0]}
                        </Button >
                        <Grid2>
                            <img src={Calci} alt='calculator' className={Styles.calci} />
                        </Grid2>

                    </Grid2>

                    <Grid2 className={Styles.buttonCard2}>
                        <Button className={Styles.button2} onClick={() => { navigate("/tools-calculators/brokerage") }}>
                            {t.buttons[1]}
                        </Button>
                        <Button className={Styles.button3} onClick={() => { navigate("/tools-calculators/margin")
                       window.scrollTo(0, 0)
                       }}>
                            {t.buttons[2]}
                        </Button>
                    </Grid2>

                    <Grid2 className={Styles.subCard}>
                        <Button className={Styles.subbtn} onClick={() => { navigate("/tools-calculators/margin")
                 window.scrollTo(0, 0)
                 }}>
                            {t.subbutton}
                        </Button>
                    </Grid2>


                </Grid2>



            </Box>
        </>
    );
}
